var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      ref: "subscribeLabel",
      staticClass: "pdp-purchase-option",
      class: {
        "is-checked": _vm.selectedProductType === _vm.PRODUCT_TYPE.SUBSCRIBE
      },
      attrs: { tabindex: "0", "aria-label": _vm.translations.subscribe.title }
    },
    [
      _c("input", {
        attrs: { name: "purchase", type: "radio" },
        domProps: {
          value: _vm.PRODUCT_TYPE.SUBSCRIBE,
          checked: _vm.selectedProductType === _vm.PRODUCT_TYPE.SUBSCRIBE
        },
        on: {
          change: function($event) {
            return _vm.setProductType(_vm.PRODUCT_TYPE.SUBSCRIBE)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "pdp-purchase-option-inner" }, [
        _c("div", { staticClass: "pdp-purchase-option-main" }, [
          _c("h5", [_vm._v(_vm._s(_vm.translations.subscribe.title))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.translations.subscribe.subTitle))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pdp-purchase-option-price" }, [
          _c("strong", [
            _vm._v(
              "\n        " + _vm._s(_vm.currentPriceFormatted) + "\n        "
            ),
            _vm.currentCostPerItem
              ? _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentCostPerItem) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.selectedProductType === _vm.PRODUCT_TYPE.SUBSCRIBE &&
      _vm.context !== _vm.CONTEXT.MACHINE
        ? _c("PurchaseOptionDropdown", {
            attrs: {
              title: _vm.translations.subscribe.chooseFrequency.title,
              subtitle: _vm.translations.subscribe.chooseFrequency.subTitle,
              options: _vm.chooseSubscriptionFrequencyOptions,
              value: _vm.selectedSellingPlan.id
            },
            on: {
              change: function($event) {
                return _vm.selectSellingPlan($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedProductType === _vm.PRODUCT_TYPE.SUBSCRIBE &&
      _vm.variants &&
      _vm.variants.length > 1 &&
      _vm.variantSelectionEnabled
        ? _c("PurchaseOptionDropdown", {
            attrs: {
              title: _vm.translations.subscribe.chooseVariant.title,
              subtitle: _vm.translations.subscribe.chooseVariant.subTitle,
              options: _vm.chooseSubscriptionVariantOptions,
              value: _vm.selectedVariant.id
            },
            on: {
              change: function($event) {
                return _vm.selectVariant($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedProductType === _vm.PRODUCT_TYPE.SUBSCRIBE &&
      _vm.shouldShowFreeGiftDropdown
        ? _c("PurchaseOptionDropdown", {
            attrs: {
              title: _vm.freeGift.title,
              subtitle: _vm.freeGift.subTitle,
              options: _vm.freeGift.options,
              value: _vm.selectedFreeGift.id
            },
            on: { change: _vm.onFreeGiftChange }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedProductType === _vm.PRODUCT_TYPE.SUBSCRIBE &&
      _vm.upSell &&
      _vm.upSell.inventoryQuantity > 0
        ? _c("PurchaseOptionDropdown", {
            attrs: {
              title: _vm.upSell.dropdown.title,
              subtitle: _vm.upSell.dropdown.subTitle,
              options: _vm.upSell.options,
              value: _vm.selectedUpsellProductQuantity
            },
            on: {
              change: function($event) {
                return _vm.setUpSellQuantity($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }